import { render, staticRenderFns } from "./telemetry-graphic.vue?vue&type=template&id=54c843fc"
import script from "./telemetry-graphic.vue?vue&type=script&lang=ts&setup=true"
export * from "./telemetry-graphic.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports